import type {ButtonDocument, Top10AiToolsSliceDefaultItem, Top10AiToolsSliceDefaultPrimary} from 'prismicio-types'
import {getButtonsData} from 'src/common/helpers'
import CtaSection from './components/CtaSection'
import DeepDives from './components/DeepDives'
import DuopolyBar from './components/DuopolyBar'
import FaqSection from './components/FaqSection'
import HeroSection from './components/HeroSection'
import KeyTakeaways from './components/KeyTakeaways'
import Leaderboard from './components/Leaderboard'
import Methodology from './components/Methodology'
import Trends from './components/Trends'
import styles from './top10AiTools.module.css'

interface Props {
  slice: {
    slice_type: string
    variation: string
    primary: Top10AiToolsSliceDefaultPrimary
    items: Top10AiToolsSliceDefaultItem[]
  }
  pageUid: string
  componentIndex: number
  buttonsData?: Array<ButtonDocument>
}

export const DefaultTop10AiTools = ({slice, pageUid, buttonsData}: Props) => {
  const p = slice.primary
  const tools = slice.items

  const {primaryButtonData: ctaButton} = getButtonsData({
    buttonsData,
    primaryButton: p.cta_button,
  })

  return (
    <section data-slice-type={slice.slice_type} data-slice-variation={slice.variation}>
      <div className={styles.reportRoot}>
        <HeroSection
          eyebrow={p.hero_eyebrow}
          title={p.hero_title}
          subtitle={p.hero_subtitle}
          desc={p.hero_desc}
          linkText={p.hero_link_text}
          linkUrl={p.hero_link_url}
          stats={p.hero_stats}
        />
        <Leaderboard
          eyebrow={p.leaderboard_eyebrow}
          title={p.leaderboard_title}
          desc={p.leaderboard_desc}
          tableNote={p.leaderboard_table_note}
          tools={tools}
        />
        <DuopolyBar
          title={p.duopoly_title}
          subtitle={p.duopoly_subtitle}
          desc={p.duopoly_desc}
          segments={p.duopoly_segments}
        />
        <KeyTakeaways eyebrow={p.takeaways_eyebrow} title={p.takeaways_title} takeaways={p.takeaways} />
        <DeepDives eyebrow={p.deep_dives_eyebrow} title={p.deep_dives_title} tools={tools} />
        <Trends eyebrow={p.trends_eyebrow} title={p.trends_title} trends={p.trends} />
        <FaqSection eyebrow={p.faq_eyebrow} title={p.faq_title} faqs={p.faqs} />
        <Methodology
          eyebrow={p.methodology_eyebrow}
          text={p.methodology_text}
          linkEyebrow={p.methodology_link_eyebrow}
          linkTitle={p.methodology_link_title}
          linkUrl={p.methodology_link_url}
        />
        <CtaSection
          eyebrow={p.cta_eyebrow}
          title={p.cta_title}
          desc={p.cta_desc}
          buttonData={ctaButton}
          backgroundImage={p.cta_background_image}
          pageUid={pageUid}
        />
      </div>
    </section>
  )
}
